const cardItems = [
  {
    title: '深夜重磅：某知名导演被曝剧组霸凌，多位演员站出来实锤',
    excerpt: '多名曾在剧组工作过的演员和工作人员联合发声，揭露该导演在片场的种种不当行为，包括言语侮辱、超时工作以及不合理的合同条款。事件持续发酵中...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20with%20dramatic%20red%20spotlight%20on%20empty%20director%20chair%2C%20shadowy%20figure%20in%20background%2C%20film%20set%20atmosphere%2C%20mysterious%20and%20tense%20mood%2C%20warm%20crimson%20highlights%20on%20dark%20background%2C%20editorial%20photo%20style%20with%20grainy%20texture&width=800&height=480&seq=card-01-director&orientation=landscape',
    tag: '娱乐圈',
    time: '2小时前',
    views: '128万',
  },
  {
    title: '某科技公司CEO涉嫌数据造假，股价单日暴跌40%',
    excerpt: '内部员工匿名向暗网吃瓜论坛投稿大量内部截图，显示该公司核心业务数据存在严重注水。目前已有投资机构启动法律程序，多名高管被限制出境...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20at%20night%20with%20flickering%20monitor%20screens%20showing%20red%20warning%20signals%2C%20empty%20executive%20desk%2C%20scattered%20documents%2C%20ominous%20atmosphere%2C%20cyberpunk%20aesthetic%20with%20red%20and%20amber%20glow%2C%20high%20contrast%20noir%20photography&width=800&height=480&seq=card-02-tech&orientation=landscape',
    tag: '科技圈',
    time: '5小时前',
    views: '96万',
  },
  {
    title: '吃瓜群疯传：某女团成员私下恋情被拍，男方身份成谜',
    excerpt: '一组高清街拍照片在各大吃瓜群内疯狂传播，照片中某当红女团成员与一神秘男子举止亲密。粉丝群体已分裂为两派，经纪公司至今未发声明...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20alley%20street%20scene%20at%20night%20with%20blurry%20figures%2C%20paparazzi%20style%20photography%2C%20neon%20red%20light%20reflections%20on%20wet%20pavement%2C%20mysterious%20romantic%20vibe%2C%20hidden%20camera%20aesthetic%2C%20dramatic%20shadows%20and%20highlights%2C%20urban%20noir%20atmosphere&width=800&height=480&seq=card-03-idol&orientation=landscape',
    tag: '娱乐圈',
    time: '8小时前',
    views: '203万',
  },
  {
    title: '某短视频平台大V被扒学历造假，人设全面崩塌',
    excerpt: '暗网吃瓜论坛网友深度挖掘发现，该拥有千万粉丝的知识类大V实际学历与宣传严重不符。其合作品牌已陆续解约，评论区全面沦陷...',
    image: 'https://readdy.ai/api/search-image?query=Shattered%20glass%20effect%20on%20dark%20background%20with%20red%20crack%20lines%2C%20broken%20certificate%20or%20diploma%20concept%2C%20dramatic%20lighting%20from%20behind%2C%20abstract%20representation%20of%20truth%20and%20deception%2C%20dark%20moody%20atmosphere%20with%20crimson%20accents%2C%20editorial%20quality&width=800&height=480&seq=card-04-fake&orientation=landscape',
    tag: '网红圈',
    time: '10小时前',
    views: '75万',
  },
  {
    title: '某城市夜店涉黄涉毒被突击检查，多名网红被带走调查',
    excerpt: '据暗网吃瓜群内知情人士透露，该夜店长期为VIP客户提供非法服务。当晚突击行动中，数位社交平台知名网红被拍到被警方带走，事件涉及面极广...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20nightclub%20exterior%20with%20police%20blue%20and%20red%20lights%20reflecting%2C%20empty%20velvet%20rope%20entrance%2C%20ominous%20night%20scene%2C%20yellow%20caution%20tape%2C%20dramatic%20noir%20photography%2C%20wet%20street%20reflections%2C%20tense%20atmosphere&width=800&height=480&seq=card-05-club&orientation=landscape',
    tag: '社会',
    time: '12小时前',
    views: '312万',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            热门爆料
          </h2>
          <span className="text-xs text-foreground-500 mt-1">每日精选 5 条劲爆内容</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, idx) => (
            <article
              key={idx}
              className={`bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer group ${
                idx === 0 ? 'md:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'h-52 md:h-64' : 'h-44'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-200 group-hover:text-primary-400 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}